import FormField from "./FormField";

const InputField = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  required,
  description,
  placeholder,
}) => {
  return (
    <FormField label={label} required={required} description={description}>
      <input
        type={type}
        name={name}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        className="flex h-10 w-full rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200"
      />
    </FormField>
  );
};

export default InputField;
